<!-- 回收说明 -->
<template>
  <div class="right-item-content">
    <div style="line-height: 2; color: rgb(51, 51, 51); font-size: 16px">
      1、礼品卡回收成功后，金额将打入您的账户余额中，您需要通过实名认证之后才可提现；<br />
      2、当选择的面值与实际面值不一致时，您将损失差额，而且会造成延迟到账，请正确选择；<br />
      3、转让成功前请不要丢弃实体卡；<br />
      4、您的账号因自身原因礼品卡被盗取或封存导致不能审核的责任由您自己承担，我们将直接撤单；<br />
      5、若您重复提交同一卡号或故意提交错误信息的，我们会取消交易，并冻结您的账户信息；<br />
      6、如果您私下将礼品卡信息交易给其他买家，并再次出售给本网站，造成的损失由您承担，我们将对您的账户信息进行冻结处理；<br />
      7、礼品卡交易在未给您打款期间出现问题的话，您应积极配合解决问题，根据要求我们将延迟打款，如果问题没有解决我们将按责任轻重来加以处理；<br />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.right-item-content {
  margin-top: 10px;
  padding: 20px;
  color: #000000e0;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  background: #f8f8fa;
  border-radius: 8px;
}
</style>